
import { FAILED_URLS, GET_FAILED_URLS_FREQUENCY } from '../lib/constants/api-urls';
import Api from "../lib/api-call";
import { changeParamsToQuery } from './commonFn';

export class FailedUrlsService {

  static instance;
  static getInstance() {
    if (!FailedUrlsService.instance) {
      FailedUrlsService.instance = new FailedUrlsService();
    }
    return FailedUrlsService.instance;
  }

  fetchFailedUrls = async (params) => {
    let newsResponse = await Api.get(`${FAILED_URLS.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }

  fetchFailedUrlsFrequency = async (params) => {
    let newsResponse = await Api.get(`${GET_FAILED_URLS_FREQUENCY.URL}${changeParamsToQuery(params)}`, []);
    return newsResponse;
  }








}

